import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface StoryCardProps {
  story: {
    id: number;
    name: string;
    age: number;
    program: string;
    achievement: string;
    duration: string;
    image: string;
    alt: string;
    beforeImage?: string;
    beforeAlt?: string;
    afterImage?: string;
    afterAlt?: string;
    quote: string;
    metrics: {
      label: string;
      value: string;
    }[];
  };
  onViewDetails: () => void;
}

const StoryCard = ({ story, onViewDetails }: StoryCardProps) => {
  // Determine if this is Amieyra Khosla's story to apply special zoom styling
  const isAmieyraStory = story.id === 10;
  
  return (
    <div className="bg-card rounded-lg shadow-card hover:shadow-hover transition-all duration-300 overflow-hidden group">
      <div className="relative h-64 overflow-hidden bg-muted">
        <AppImage
          src={story.image}
          alt={story.alt}
          className={`w-full h-full ${
            isAmieyraStory 
              ? 'object-cover scale-110 group-hover:scale-125' :'object-contain group-hover:scale-105'
          } transition-transform duration-500`}
        />
        <div className="absolute top-4 right-4 bg-accent text-accent-foreground px-3 py-1 rounded-full text-xs font-heading font-bold">
          {story.program}
        </div>
      </div>

      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-xl font-heading font-bold text-primary mb-1">
              {story.name}
            </h3>
            <p className="text-sm text-text-secondary">
              Age {story.age} • {story.duration}
            </p>
          </div>
        </div>

        <p className="text-text-primary font-semibold mb-3">
          {story.achievement}
        </p>

        <blockquote className="border-l-4 border-accent pl-4 py-2 mb-4 italic text-text-secondary">
          &quot;{story.quote}&quot;
        </blockquote>

        <div className="grid grid-cols-2 gap-3 mb-4">
          {story.metrics.map((metric, index) => (
            <div key={index} className="bg-muted rounded-lg p-3">
              <p className="text-xs text-text-secondary mb-1">{metric.label}</p>
              <p className="text-lg font-heading font-bold text-accent">
                {metric.value}
              </p>
            </div>
          ))}
        </div>

        <button
          onClick={onViewDetails}
          className="w-full bg-primary text-primary-foreground py-3 rounded-md font-heading font-semibold hover:bg-primary/90 transition-colors duration-300 flex items-center justify-center space-x-2"
        >
          <span>View Full Story</span>
          <Icon name="ArrowRightIcon" size={16} variant="outline" />
        </button>
      </div>
    </div>
  );
};

export default StoryCard;